<template>
  <div
    class="trading-container main-wrapper title_container first"
    :class="route.path == '/analysis' ? 'analysis' : ''"
  >
    <h1>{{ $t("trading.title.01") }}</h1>
  </div>

  <!-- [추가] 모바일/스크롤 이동용 탭 메뉴 -->
  <div class="scroll-tab-container sticky-tab">
    <button
      class="scroll-tab"
      :class="{ active: currentTab === 'chart' }"
      @click="scrollToSection('chart')"
    >
      {{ kind }} {{ $t("trading.chart") }}
    </button>
    <button
      class="scroll-tab"
      :class="{ active: currentTab === 'trade' }"
      @click="scrollToSection('trade')"
    >
      {{ $t("trading.title.01") }}
    </button>
  </div>

  <div
    class="trading-container main-wrapper chart-container"
    :class="isDarkMode ? 'dark' : 'light'"
    v-if="route.path === '/trading-chart' || route.path === '/trading-test'"
    id="section-chart"
  >
    <ul>
      <li :class="{ active: activeNo === 1 }" @click="activeNo = 1">
        {{ $t("trading.title.02") }}
      </li>
      <li :class="{ active: activeNo === 2 }" @click="checkUserAuth('sm')">
        {{ $t("trading.title.03") }}
      </li>
    </ul>
    <ChartPremium v-if="activeNo === 1" :key="kind" :kind="kind" />
    <ChartSmart v-if="activeNo === 2" :key="kind" :kind="kind" />
  </div>
  <div class="trading-container main-wrapper"></div>
  <div id="section-trade" class="trading-container main-wrapper">
    <div class="left-pos">
      <CoinSearchView />
      <TradingView
        class="trading-view"
        :positions="singlePosition"
        :openOrderList="singleOrderList"
      />
    </div>
    <OrderBookView class="transact-view" />
    <TransactView class="transact-view" />
  </div>
  <div class="trading-container main-wrapper">
    <HistoryView class="history-view" />
    <AccountView class="account-view" />
  </div>
  <ModalAlert
    :isVisible="alertDialog.isVisible"
    :content="alertDialog.content"
    @closeDialogHandler="closeAlertDialogHandler"
    :is-btn="true"
  />
</template>

<script setup>
import ModalAlert from "@/components/common/modal/ModalAlert.vue";
import TradingView from "@/components/trading/TradingView.vue";
import CoinSearchView from "@/components/trading/CoinSearchView.vue";
import TransactView from "@/components/trading/TransactUserView.vue";
import HistoryView from "@/components/trading/HistoryView.vue";
import OrderBookView from "@/components/trading/OrderBookView.vue";
import AccountView from "@/components/trading/AccountView.vue";
import ChartPremium from "@/components/trading/chart/ChartPremium.vue";
import ChartSmart from "@/components/trading/chart/ChartSmart.vue";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onBeforeMount,
  onMounted,
  ref,
} from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import axios from "axios";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const store = useStore();
const route = useRoute();
// const FIVE_MINUTES = 5 * 60 * 1000;
const FIVE_MINUTES = 30000;
let intervalId;
const socket = ref(null);
const activeNo = ref(1);
const alertDialog = ref({
  isVisible: false,
  content: "",
});

const isDarkMode = computed(() => store.getters["displayed/isDarkMode"]);
const userNo = computed(() => store.state.account.userNo);
const userState = computed(() => store.state.account.userState);
const isMobile = computed(() => store.state.account.isMobile);
const duplicateCheck = computed(() => store.state.account.duplicateCheck);
const positionList = computed(() => store.state.user_history.positionList);
const kind = computed(() => store.getters["transact/getTicker"]);
const userAuth = computed(() => store.state.account.userAuth);
const isAuth = ref(false);

async function getUserCountryCode() {
  const response = await axios.get("https://get.geojs.io/v1/ip/country.json", {
    withCredentials: false,
  });
  const data = await response.data;
  store.commit("transact/setCountryCode", data.country);
  //   store.commit("transact/setCountryCode", "CN");
  if (route.path === "/trading-test") {
    const companyIps = [
      process.env.VUE_APP_COMPANY_IP_1,
      process.env.VUE_APP_COMPANY_IP_2,
      process.env.VUE_APP_COMPANY_IP_3,
      process.env.VUE_APP_COMPANY_IP_4,
    ];
    if (!companyIps.includes(data.ip)) {
      location.href = isMobile.value
        ? "https://www.tryex.io/m/"
        : "https://www.tryex.io/";
    }
  }
}

const handleDuplicateCheck = async () => {
  if (process.env.NODE_ENV === "development") return;
  await store.dispatch("account/getDuplicateCheck");
  if (duplicateCheck.value === 1) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("trading.common.duplicate");
  } else if (duplicateCheck.value === 2) {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("trading.error.1");
  }
};

const closeAlertDialogHandler = () => {
  if (!isAuth.value) {
    location.href = isMobile.value
      ? "https://www.tryex.io/m/"
      : "https://www.tryex.io/";
  }
  alertDialog.value.isVisible = false;
  isAuth.value = false;
};
const resizeHandler = () => {
  const isMobileView = window.innerWidth <= 1024;
  store.commit("account/setIsMobile", isMobileView);
};

const connectSocket = async () => {
  if (socket.value) socket.value.close();
  const url = `wss://mocktrade-scheduler.com/ws/${userNo.value}
`;
  socket.value = new WebSocket(url);

  socket.value.onmessage = (e) => {
    let data;
    try {
      data = JSON.parse(e.data);
      if (data) {
        // if (
        //   data.total === undefined ||
        //   data.total === null ||
        //   isNaN(Number(data.total))
        // ) {
        //   console.warn(
        //     "🚨 [웹소켓 에러] data.total이 비정상입니다. 전체 데이터:",
        //     data,
        //   );
        // }

        store.commit("account/setUnrealizePnl", data.total ?? 0);
        store.commit("user_history/setPositionPnlList", data.data);
        if (data.trigger) {
          store.dispatch("account/fetchUserWallet");
          store.dispatch("user_history/fetchAllHistory", userNo.value);
        }
      }
    } catch (err) {
      console.error("error websocket", err);
    }
  };
};

const checkUserAuth = (type) => {
  if (userAuth.value[type]) {
    activeNo.value = 2;
  } else {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("alert.upgradeSmart");
    isAuth.value = true;
    return;
  }
};

// [추가] 탭 상태 및 스크롤 함수
const currentTab = ref("chart"); // 기본값: 첫 번째 탭
const scrollOffset = 120;

// [탭 클릭 시 스크롤 이동]
const scrollToSection = (sectionName) => {
  currentTab.value = sectionName; // 클릭 즉시 탭 상태 변경 (체감 속도 향상)
  const targetId = sectionName === "chart" ? "section-chart" : "section-trade";
  const targetElement = document.getElementById(targetId);

  if (targetElement) {
    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - scrollOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }
};

// [스크롤 감지 로직 (Scroll Spy)]
const handleScrollSpy = () => {
  // 스크롤 위치 (현재 스크롤 위치 + 오프셋 약간 여유 주기)
  const currentScrollPosition = window.pageYOffset + scrollOffset + 10;

  const chartSection = document.getElementById("section-chart");
  const tradeSection = document.getElementById("section-trade");

  if (!chartSection || !tradeSection) return;

  const chartTop = chartSection.offsetTop;
  const tradeTop = tradeSection.offsetTop;

  // 스크롤 위치가 trade 섹션 상단(또는 그 이상)을 넘었을 때
  if (currentScrollPosition >= tradeTop) {
    currentTab.value = "trade";
  }
  // 그 전이면 차트 섹션으로 판별
  else {
    currentTab.value = "chart";
  }
};

onBeforeMount(async () => {
  await getUserCountryCode();
});
onMounted(async () => {
  await store.dispatch("account/getUserInfo");
  if (userNo.value) {
    handleDuplicateCheck();
    await store.dispatch("account/fetchUserState");
    if (userState.value) {
      await store.dispatch("account/fetchUserWallet");
      await store.dispatch("user_history/fetchAllHistory", userNo.value);
      await connectSocket();
    }
    intervalId = setInterval(handleDuplicateCheck, FIVE_MINUTES);
  } else {
    alertDialog.value.isVisible = true;
    alertDialog.value.content = t("trading.common.loginMsg");
  }
  await nextTick();
  window.addEventListener("resize", resizeHandler);
  const isMobileView = window.innerWidth <= 1024;
  store.commit("account/setIsMobile", isMobileView);

  window.addEventListener("scroll", handleScrollSpy);
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeHandler);
  clearInterval(intervalId);
  if (socket.value) socket.value.close();

  window.removeEventListener("scroll", handleScrollSpy);
});
</script>

<style lang="scss" scoped>
@use "@/assets/scss/components/trading/index.scss";

/* [추가] 탭 상단 고정 스타일 */
.scroll-tab-container.sticky-tab {
  display: flex;
  width: 100%;
  margin-bottom: 20px;

  position: -webkit-sticky;
  position: sticky;
  top: 60px;
  z-index: 99;
}

.scroll-tab {
  flex: 1;
  background: var(--bg-color);
  border: none;
  padding: 15px 0;
  font-size: 16px;
  font-weight: 500;
  color: var(--Grayscale-Gray40, #929caa);
  position: relative;
  cursor: pointer;
  transition: color 0.3s;
}

.scroll-tab.active {
  color: var(--primary-color);
  font-weight: bold;
}

.scroll-tab.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: var(--primary-color);
}

@media screen and (min-width: 1025px) {
  .scroll-tab-container.sticky-tab {
    display: none;
  }
}
</style>
